/** @jsx jsx */
import { jsx } from 'packages/theming';
import { Fragment } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import Markdown from 'react-markdown';
import breaks from 'remark-breaks';
import { Link } from 'react-router-dom';

import { Box, constants, Typography } from '@match/react-component-library';

const { FONT_SIZE, FONT_WEIGHT, SPACE, SEMANTIC_COLOR_NAME } = constants;

interface TopicViewProps {
  answer: string;
  categoryId: number;
  categoryName?: string;
  id: number;
  showHelpBreadcrumb?: boolean;
  title: string;
}

const TopicView: React.FunctionComponent<TopicViewProps> = ({
  answer,
  categoryId,
  categoryName,
  showHelpBreadcrumb,
  title,
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      maxWidth={830}
      height="100%"
      paddingBottom={SPACE.LARGE}
    >
      <Typography as="p" color={SEMANTIC_COLOR_NAME.GRAY_50}>
        {showHelpBreadcrumb && (
          <Fragment>
            <Link to="/">
              <Typography color={SEMANTIC_COLOR_NAME.GRAY_50}>
                <FormattedMessage {...messages.help} />
              </Typography>
            </Link>{' '}
            &gt; &nbsp;
          </Fragment>
        )}
        <Link to={`/${categoryId}`}>
          <Typography color={SEMANTIC_COLOR_NAME.GRAY_50}>{categoryName || categoryId}</Typography>
        </Link>{' '}
        &gt; {title}
      </Typography>
      <Box paddingTop={SPACE.SMEDIUM} paddingBottom={SPACE.MEDIUM}>
        <Typography fontSize={FONT_SIZE.XLARGE} fontWeight={FONT_WEIGHT.BOLD}>
          {title}
        </Typography>
      </Box>
      <Markdown plugins={[breaks]} css={markdownClass} source={answer} />
    </Box>
  );
};

// restores default styles that our css reset wipes out so markdown renders as expected
const markdownClass = {
  p: {
    margin: '16px 0',
  },
};

export default TopicView;

const messages = defineMessages({
  help: {
    id: 'src/modules/components/TopicView/TopicView:help',
    description: 'back to categories link text',
    defaultMessage: 'Help',
  },
});
